<template>
  <div class="notification-filter">
    <div class="tag-list">
      <div v-for="item in types" :key="item" class="tag-item" @click="handlerSelect(item)" :class="`${state.active === item ? 'active' : ''}`">
        {{ item }}
      </div>
    </div>
  </div>
  <div class="notification-list">
    <div v-for="(item, index) in notifications" :key="index" :class="`notification-item`">
      <IconLiveStream v-if="item.content_type && item.content_type === 'live'" />
      <IconNewspasper v-if="item.content_type && (item.content_type === 'aksi' || item.content_type === 'agenda')" />
      <IconPolling v-if="item.content_type && item.content_type == 'polling'" />
      <div class="notification-content" @click="handlerClick(item)">
        <span class="title" style="min-height: 30px;">
          {{ item.title }}
        </span>
        <span class="date" v-if="item.content_type && item.content_type !== 'aksi'">
          {{ item.content_type === 'live' ? useFormatDate(item.streaming_start_date) : useFormatDate(item.start_date.Time) }} -
          {{ item.content_type === 'live' ? useFormatDate(item.streaming_end_date) : useFormatDate(item.end_date.Time) }}
        </span>
        <span class="date" v-if="item.content_type && item.content_type === 'aksi'">
          {{ useFormatDate(item.content_date.Time) }}
        </span>
      </div>
    </div>
    <!-- <div v-if="notifications.length >= 5" @click="loadMore" class="load-more-notification">
      Muat lebih banyak
    </div> -->
    <div v-if="notifications.length === 0" class="load-notification">
      Tidak ada notifikasi
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, reactive, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import IconLiveStream from './icons/IconLiveStream.vue'
import IconNewspasper from './icons/IconNewspasper.vue'
import { useFormatDate } from '../../composable/useFormatDate'
import IconPolling from './icons/IconPolling.vue'

// const bodyEl = document.getElementsByTagName('body')[0]
const store = useStore()
const router = useRouter()
const types = ['Semua', 'Agenda', 'Aksi', 'Polling']
const URL_MAIN_SITE = process.env.VUE_APP_BACK_HOME_URL
const state = reactive({
  active: 'Semua'
})

const handlerSelect = (type) => {
  state.active = type
}

const handlerClick = (notification) => {
  const type = notification.content_type
  if (type === 'live') {
    window.open(`${URL_MAIN_SITE}#livestream`, '_blank')
    return
  }
  if (type === 'agenda' || type === 'aksi') {
    window.open(`${URL_MAIN_SITE}${type === 'aksi' ? 'berita' : type}/${notification.url_link.String}`)
  }

  if (type === 'polling') {
    router.push({ name: 'polls', params: { id: notification.content_id.Int64 } })
  }
}

const notifications = computed(() => {
  if (state.active === 'Semua') {
    return [...store.getters.getLivestream, ...new Map(store.getters.getNotification.map(v => [v.notification_id, v])).values()]
  } else {
    return store.getters.getNotification
  }
})

const notificationType = {
  Semua: '',
  Agenda: 'agenda',
  Aksi: 'aksi',
  Polling: 'polling'
}

const pagination = reactive({
  PAGE: 1,
  LIMIT: 10
})

const loadMore = () => {
  pagination.PAGE++
  store.dispatch('getNotificationList', {
    type: notificationType[state.active],
    page: pagination.PAGE,
    limit: pagination.LIMIT
  })
}

onMounted(() => {
  store.dispatch('getLivestream')
  store.dispatch('getNotificationList', {
    type: notificationType[state.active],
    limit: pagination.LIMIT,
    page: pagination.PAGE
  })
  const element = document.querySelector('.notification-list')
  element.addEventListener('scroll', () => {
    if (element.scrollTop + element.clientHeight >= element.scrollHeight - 1) {
      loadMore()
    }
  })

  const appEl = document.getElementsByTagName('body')[0]
  appEl.style.overflow = 'hidden'
})

onBeforeUnmount(() => {
  store.dispatch('resetPage', { page: 1 })
  const element = document.querySelector('.notification-list')
  element.removeEventListener('scroll', () => {
    if (element.scrollTop + element.clientHeight === element.scrollHeight) {
      loadMore()
    }
  })
})

watch(() => state.active, () => {
  store.dispatch('resetPage', { page: 1 })
  store.dispatch('getNotificationList', {
    type: notificationType[state.active]
  })
})

</script>
<style lang="scss" scoped>
.notification-filter {
  padding: .6em;

  .tag-list {
    display: flex;
    padding: .4em;
  }

  .tag-item {
    border: 1px solid $blue;
    cursor: pointer;
    padding: .2em 1em;
    border-radius: 20px;
    color: $blue;
    font-weight: 500;
    margin: 0 .2em;
    font-size: 14px;
    height: 31px;

    &.active {
      background-color: $blue;
      color: $white;
    }
    &:hover {
      background-color: $blue;
      color: $white;
    }
  }
}

.notification-list {
  margin-top: 1em;
  overflow-x: scroll;
  height: calc(100vh - 170px);

  @media only screen and (min-width: 600px) {
    height: 330px;
    &::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
    }
    /* Optional: show position indicator in red */
    &::-webkit-scrollbar-thumb {
        // background: #FF0000;
    }
  }

  .notification-item {
    padding: 2em;
    display: flex;
    background-color: $white;

    &:hover {
      background-color: #ebeff9;
    }

    &.active {
      background-color: #ebeff9;
    }

    .notification-content {
      margin-left: .8em;
      justify-content: center;
    }
  }
}

.load-more-notification {
  cursor: pointer;
  font-weight: bold;
  color: $blue;
  width: 100%;
  padding: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
}
.load-notification {
  font-weight: bold;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
